import styled from 'styled-components';
import { Text } from '@adobe/react-spectrum';
import { Button } from 'components/basic/button';
import { Overlay } from 'components/basic/overlay';
import { Loading } from 'components/basic/loading';

const RetryLayout = styled.div`
  text-align: center;
  min-height: calc(100vh - 62px);
`;

const TextLayout = styled.div`
  display: grid;
  justify-content: center;
  padding-top: 20px;
  text-align: left;
`;

interface RetryProps {
  loading: boolean;
  retryMethod: () => void;
}

export const Retry = (props: RetryProps) => {
  const { loading, retryMethod } = props;

  return (
    <RetryLayout>
      <TextLayout>
        <Text>処理に失敗しました</Text>
      </TextLayout>
      <Button disabled={loading} variant={'cta'} onClick={retryMethod}>
        再実行
      </Button>
      {loading && (
        <Overlay>
          <Loading />
        </Overlay>
      )}
    </RetryLayout>
  );
};
